import { apiRequest, toFormData } from './config';
import { normalizeBlogSlug } from '@/lib/utils/blog';

/**
 * Blog API - Optimized with ISR and granular caching
 */

export const getBlogPosts = (params = {}) => 
  apiRequest('blogs', { 
    method: 'GET', 
    params,
    next: {
      tags: ['blogs', 'blog-list']
    }
  });

export const getBlogPost = (id) => 
  apiRequest(`blogs/${id}`, {
    next: {
      tags: ['blogs', `blog-${id}`]
    }
  });

export const getBlogPostBySlug = (tag) => {
  const slug = normalizeBlogSlug(tag);
  if (!slug) return Promise.resolve(null);

  return apiRequest(`blogs/${slug}`, {
    next: {
      tags: ['blogs', `blog-tag-${slug}`]
    }
  }).then((response) => {
    if (Array.isArray(response)) return response[0] || null;
    return response?.blog || response?.data?.blog || response;
  });
};

export const createBlogPost = (postData) => 
  apiRequest('blogs', { 
    method: 'POST', 
    body: toFormData(postData) 
  });

export const updateBlogPost = (id, postData) => 
  apiRequest(`blogs/${id}`, { 
    method: 'PATCH', 
    body: toFormData(postData) 
  });

export const deleteBlogPost = (id) => 
  apiRequest(`blogs/${id}`, { method: 'DELETE' });
